import { createFileRoute } from '@tanstack/react-router'
import AssetContainer from 'Asset/containers/AssetContainer'
import { assetQueries } from 'Asset/utils/queries'
import { claimTypesEnum } from 'User/utils/claims'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard } from '../-guard'
import { prefetchWhenAuthenticated } from '../-prefetch'

export const Route = createFileRoute('/assets/$id')({
    loader: ({ context, params }) =>
        prefetchWhenAuthenticated(context.queryClient, assetQueries.detail(Number(params.id))),
    pendingComponent: () => <PageSkeleton variant="detail" />,
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_asset]}>
            <AssetContainer />
        </Guard>
    ),
})
